import PropTypes from "prop-types"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter, t) => [
  {
    title: t("clients.table.name"),
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: 200,
    "aria-sort": getSortDirection(sorter, "sort_by_user_full_name"),
    "aria-label": t("clients.table.aria_name_sortable"),
    render: (text, record) => {
      return (
        <button
          type="button"
          style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
          onClick={(e) => {
            e.stopPropagation()
            if (window && window.__navigateToClient) {
              window.__navigateToClient(record.client_id)
            }
          }}
        >
          {text}
        </button>
      )
    }
  },
  {
    title: t("clients.table.group"),
    dataIndex: "group",
    key: "group",
    sorter: true,
    width: 120,
    "aria-sort": getSortDirection(sorter, "sort_by_groups"),
    "aria-label": t("clients.table.aria_group_sortable")
  },
  {
    title: t("clients.table.email"),
    dataIndex: "email",
    key: "email",
    width: 150,
    "aria-label": t("clients.table.aria_email")
  },
  {
    title: t("clients.table.phone"),
    dataIndex: "phone",
    key: "phone",
    width: 160,
    "aria-label": t("clients.table.aria_phone")
  },
  {
    title: t("clients.table.last_experience"),
    dataIndex: "last_booked_trip_title",
    key: "last_booked_trip_title",
    width: 150,
    ellipsis: true,
    "aria-label": t("clients.table.aria_last_experience")
  },
  {
    title: t("clients.table.experience_date"),
    dataIndex: "experience_date",
    key: "experience_date",
    sorter: true,
    width: 150,
    ellipsis: true,
    align: "right",
    "aria-sort": getSortDirection(sorter, "sort_by_last_trip_date"),
    "aria-label": t("clients.table.aria_experience_date_sortable")
    // defaultSortOrder: "descend" // Default sort by date descending
  },
  {
    title: t("clients.table.ytd_spend"),
    dataIndex: "ytd_spend",
    key: "ytd_spend",
    sorter: true,
    width: 120,
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_total_booking_amount"),
    "aria-label": t("clients.table.aria_ytd_spend_sortable")
  },
  {
    title: t("clients.table.actions"),
    dataIndex: "actions",
    width: 60,
    align: "right",
    key: "actions",
    "aria-label": t("clients.table.aria_actions")
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
